import { Divider as MuiDivider } from '@mui/material';


export const Divider = () => {
  return <MuiDivider sx={{ width: 48, opacity: 0.4, borderColor: 'primary.main' }}/>;
};
